var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',{staticClass:"app",attrs:{"data-cy":"app"}},[_c('AppLoadingLayer'),_c('AppAlert'),_c('AppDialog'),_c('router-view'),_c('PrintVersion'),_c('span',{attrs:{"id":"appVersion"}},[_vm._v(_vm._s(_vm.appVersion))])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }